/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MembershipLinkRequest interface.
 */
export function instanceOfMembershipLinkRequest(value) {
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    return true;
}
export function MembershipLinkRequestFromJSON(json) {
    return MembershipLinkRequestFromJSONTyped(json, false);
}
export function MembershipLinkRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'userId': json['user_id'],
    };
}
export function MembershipLinkRequestToJSON(json) {
    return MembershipLinkRequestToJSONTyped(json, false);
}
export function MembershipLinkRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'user_id': value['userId'],
    };
}
